import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Ruler, Gem, Hammer } from 'lucide-react';

const WhyChooseUs = () => {
  const features = [
    {
      icon: <Hammer size={32} />,
      title: 'Precision Craftsmanship',
      description: 'Every cabinet is built with attention to structural integrity and refined detailing.'
    },
    {
      icon: <Ruler size={32} />,
      title: 'Architectural Approach',
      description: 'We design with intention, balance and spatial awareness.'
    },
    {
      icon: <Gem size={32} />,
      title: 'Premium Materials',
      description: 'We use high-quality materials designed for longevity and elegance.'
    },
    {
      icon: <ShieldCheck size={32} />,
      title: 'Seamless Installation',
      description: 'From concept to completion, every step is executed with care.'
    }
  ];

  return (
    <section className="py-20 bg-neutral/5 text-primary">
      <div className="container-custom">
        <div className="text-center mb-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-4xl md:text-5xl font-bold mb-6">Why Choose Us</h2>
            <div className="h-1 w-24 bg-accent mx-auto"></div>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group text-center"
            >
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-white text-primary mb-8 group-hover:bg-primary group-hover:text-white transition-all duration-500 shadow-sm">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold mb-4 uppercase tracking-wider">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed font-light">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
